// removed by extract-text-webpack-plugin
module.exports = {"modal":"bookmark__modal___3adpz","vis-list-empty":"bookmark__vis-list-empty___1431Y","bookmark-list-util":"bookmark__bookmark-list-util___3-5co"};